import React from 'react';
import { Message } from 'semantic-ui-react';
import { SecondaryBlankLink } from '../common/links';

export function Maintenance({ service }: { service: string }) {
  return (
    <Message
      content={
        <span>
          Due to system maintenance {service} is temporary disabled. We expect to have the
          functionality restored by {process.env.REACT_APP_MAINTENANCE_TIME_UNTIL}.{' '}
          {process.env.REACT_APP_MAINTENANCE_LINK && (
            <>
              You can follow{' '}
              <SecondaryBlankLink href={process.env.REACT_APP_MAINTENANCE_LINK}>
                this forum topic
              </SecondaryBlankLink>{' '}
              for updates.
            </>
          )}
        </span>
      }
      warning
    />
  );
}
